import Script from "next/script";
import { useEffect, useState } from "react";
import styles from "./ClearPayMessage.module.scss";
import { RuntimeConfig } from "../../types/types";

type Props = {
  skuId: string;
  currentPrice?: string;
  isSelected: boolean;
  shouldExcludeProduct: boolean;
  runtimeConfig: RuntimeConfig;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "square-placement": {
        "data-mpid": string;
        "data-placement-id": string;
        "data-page-type": string;
        "data-amount"?: string;
        "data-currency": string;
        "data-consumer-locale": string;
        "data-item-skus": string;
        "data-is-eligible": string;
      };
    }
  }
}

export const ClearPayMessageUI = ({
  skuId,
  currentPrice,
  isSelected,
  shouldExcludeProduct,
  runtimeConfig,
}: Props) => {
  const [amount, setAmount] = useState<string | undefined>("");

  useEffect(() => {
    if (isSelected) {
      setAmount(currentPrice);
    }
  }, [isSelected, currentPrice]);

  if (shouldExcludeProduct) return;

  const ClearPaySquareElement = () => (
    <square-placement
      data-mpid={runtimeConfig.clearPayMPID!}
      data-placement-id={runtimeConfig.clearPayPlacementId!}
      data-page-type="product"
      data-amount={amount}
      data-currency="GBP"
      data-consumer-locale="UK"
      data-item-skus={skuId}
      data-is-eligible="true"
    />
  );

  return (
    <>
      <Script async src={runtimeConfig?.clearPayScriptURL} />
      <div
        className={styles.ClearPayMessage__block}
        data-testid="clearpay-message-container"
      >
        <ClearPaySquareElement />
      </div>
    </>
  );
};
